import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { StoreService } from '../../shared/services/store.service';
import { OffcanvasCartService } from 'src/app/shared/services/offcanvas-cart.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { RootService } from 'src/app/shared/services/root.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { Configuration } from 'src/app/enum/Configuration';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DrawerService } from 'src/app/services/drawer.service';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { ActiveUserStorage } from 'src/app/services/active-user-storage.service';
import { HomeshoppingDataService } from 'src/app/services/homeshopping-data.service';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    title: string = "title from child page";
    @Input() layout: 'classic' | 'compact' = 'classic';
    public menuItems: any;
    isHovering: boolean = false;
    currentUrl: string;
    configuration = Configuration
    private subscription: Subscription;
    sessionDataString: any;
    userImage: any;
    isOrderAvailable
    isLoggedIn: boolean = false;
    constructor(public store: StoreService, private navigation: NavigationService,
        private offcanvasCart: OffcanvasCartService,
        public cart: CartService,
        public wishlist: WishlistService,
        public root: RootService,
        private session: UserSessionService,
        private router: Router,
        private authService: AuthenticationService,
        private drawerService: DrawerService,
        public sharedDataService: SharedDataService,
        public activeUserStorage: ActiveUserStorage,
        private homeshoppingDataService: HomeshoppingDataService,
        private msalService: MsalService,
    ) {
        this.currentUrl = this.router.url;
        const menu = this.session.getLocalStorageWithKey('menu');
        if (menu) {
            this.menuItems = JSON.parse(menu);
        }
        this.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    }

    ngOnInit() {
        this.homeshoppingDataService.isOrderAvailable$.subscribe(value => {
            console.log('Order Available in header:', value);
        });
        this.setImage();
        this.subscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.url;
            }
        });
    }
    handleOrderEvent(data: any) {
        console.log('Order Available:', data);
        this.isOrderAvailable = data; // Optional if you're storing it
    }
    setImage() {
        this.authService.getuserImage().subscribe({
            next: (res: any) => {
                this.sessionDataString = JSON.parse(localStorage.getItem(this.session.localStorageSessionKey));
                this.userImage = localStorage.getItem('userImg');
                if (this.userImage?.includes("data:image")) {
                    this.userImage;
                } else {
                    this.userImage = null;
                }
            },
            error: (error) => {
                console.log("testerror : ", error);
            },
        });
    }

    personIcon() {
        switch (this.sessionDataString?.gender) {
            case 1:
                return true;
            case '1':
                return true;
            case 2:
                return true;
            case '2':
                return true;
            default:
                return false;
        }
    }

    toggleDrawer() {
        this.drawerService.toggleDrawer();
    }

    toggleSubMenu(selectedMenu: any) {
        this.menuItems.forEach((menu) => {
            menu.showSubMenu = menu === selectedMenu;
        });
    }

    logout() {
        this.msalService.instance.logoutRedirect({
            postLogoutRedirectUri: '/auth/login'
        });
        localStorage.clear();
        this.navigation.login();
    }

    checkCoverage() {
        if(this.currentUrl === '/networkstatus') {
            window.location.href = "https://portal.home-connect.co.za/checkcoverage/coverage/0";
        }
        this.navigation.checkCoverage(0);
    }

    openMyProfile() {
        this.navigation.myaccount(1);
    }

    onChangePassword() {
        this.navigation.myaccount(2);
    }

    signin(){
        window.location.href = "https://portal.home-connect.co.za/auth/login";
    }
}
